<div class="container">
  <h1 class="title">{{ title }}</h1>

  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="FormsCardHeader">Filter EOI applicants</h2>
      <div (click)="clearFilters()" (keydown)="clearFilters()" class="link">Clear filters</div>
    </div>
    <card-body>
      <form [formGroup]="eoiApplicantForm" (ngSubmit)="submit()">
        <div class="data-container">
          <div class="text-input">
            <div class="row-input">
              <dxo-text-input
                [label]="applicantData.employeeNameOrId.label ?? ''"
                [maxlength]="80"
                formControlName="employeeNameOrId"
              ></dxo-text-input>
              <dxo-text-input
                [label]="applicantData.applicantName.label ?? ''"
                [maxlength]="80"
                formControlName="applicantName"
                (valueChange)="applicantName$.next($event)"
              ></dxo-text-input>
            </div>
            <div class="row-input">
              <dxo-text-input
                [label]="applicantData.submittedFromDate.label ?? ''"
                [maxlength]="80"
                type="date"
                [hint]="'From date (MM/DD/YYYY)'"
                formControlName="submittedFromDate"
                [error]="!validateDateFormat(eoiApplicantForm.controls.submittedFromDate.value)"
                [errorMessage]="dateFormatMessage"
              ></dxo-text-input>
              <div class="placeholder-label">
                <div class="block"></div>
                <dxo-text-input
                  [maxlength]="80"
                  type="date"
                  [hint]="'To date (MM/DD/YYYY)'"
                  formControlName="submittedToDate"
                  [error]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.submittedFromDate.value,
                      eoiApplicantForm.controls.submittedToDate.value
                    ) || !validateDateFormat(eoiApplicantForm.controls.submittedToDate.value)
                  "
                  [errorMessage]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.submittedFromDate.value,
                      eoiApplicantForm.controls.submittedToDate.value
                    )
                      ? dateErrorMessage
                      : !validateDateFormat(eoiApplicantForm.controls.submittedToDate.value)
                        ? dateFormatMessage
                        : ''
                  "
                ></dxo-text-input>
              </div>
            </div>
            <div class="row-input">
              <dxo-text-input
                [label]="applicantData.decisionFromDate.label ?? ''"
                [maxlength]="80"
                type="date"
                [hint]="'From date (MM/DD/YYYY)'"
                formControlName="decisionFromDate"
                [error]="!validateDateFormat(eoiApplicantForm.controls.decisionFromDate.value)"
                [errorMessage]="dateFormatMessage"
              ></dxo-text-input>
              <div class="placeholder-label">
                <div class="block"></div>
                <dxo-text-input
                  [maxlength]="80"
                  type="date"
                  [hint]="'To date (MM/DD/YYYY)'"
                  formControlName="decisionToDate"
                  [error]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.decisionFromDate.value,
                      eoiApplicantForm.controls.decisionToDate.value
                    ) || !validateDateFormat(eoiApplicantForm.controls.decisionToDate.value)
                  "
                  [errorMessage]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.decisionFromDate.value,
                      eoiApplicantForm.controls.decisionToDate.value
                    )
                      ? dateErrorMessage
                      : !validateDateFormat(eoiApplicantForm.controls.decisionToDate.value)
                        ? dateFormatMessage
                        : ''
                  "
                ></dxo-text-input>
              </div>
            </div>
          </div>
          <div id="eoi-container">
            <dxo-label-value [label]="'EOI status'"></dxo-label-value>
            <div id="status-container">
              <div class="status" *ngFor="let status of statusList">
                <div
                  class="status-value"
                  [class.selected]="isSelected(status)"
                  (click)="toggleStatusSelection(status)"
                  (keydown)="toggleStatusSelection(status)"
                >
                  {{ status }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </card-body>
  </dxo-card>

  <div class="eoi-table-container">
    <dxo-card>
      <div class="header-container">
        <h2 class="card-body-header" data-e2e="FormsCardHeader">EOI applicants</h2>
        <div (click)="exportTableToXLSX()" (keydown)="exportTableToXLSX()" class="link">Download XLSX</div>
      </div>
      <div class="loader-container">
        <dxo-circular-loader *ngIf="isLoading" [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
      </div>
      <card-body id="eoi-card" *ngIf="applicants$ | async as applicants">
        <dxo-data-table
          [headers]="tableHeaders"
          [items]="applicants.listEoi"
          [showCardViewWhenMobile]="true"
          [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
        >
          <ng-template dxoHeaderKey="employee">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('EmployeeName')"
              (keypress)="onClickTableHeader('EmployeeName')"
            >
              Employee name
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'EmployeeName'
                "
                [color]="searchParameter.sortField === 'EmployeeName' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="status">
            <span
              tabindex="0"
              class="sort-header"
              (click)="onClickTableHeader('Status')"
              (keypress)="onClickTableHeader('Status')"
            >
              Status
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'Status'
                "
                [color]="searchParameter.sortField === 'Status' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>

          <ng-template dxoKey="status" let-item>
            <span class="row-cell">
              <span class="status-indicator" [style.background-color]="item.indicator"></span>
              {{ item.status }}
            </span>
          </ng-template>

          <ng-template dxoHeaderKey="applicant">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('ApplicantName')"
              (keypress)="onClickTableHeader('ApplicantName')"
            >
              Applicant
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'ApplicantName'
                "
                [color]="searchParameter.sortField === 'ApplicantName' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="coverage">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('Coverage')"
              (keypress)="onClickTableHeader('Coverage')"
            >
              Coverage
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending && searchParameter.sortField === 'Coverage'
                "
                [color]="searchParameter.sortField === 'Coverage' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="amount">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('Amount')"
              (keypress)="onClickTableHeader('Amount')"
            >
              Amount
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending && searchParameter.sortField === 'Amount'
                "
                [color]="searchParameter.sortField === 'Amount' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="submitted">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('SubmittedFromDate')"
              (keypress)="onClickTableHeader('SubmittedFromDate')"
            >
              Submitted
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'SubmittedFromDate'
                "
                [color]="searchParameter.sortField === 'SubmittedFromDate' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="decision">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('DecisionToDate')"
              (keypress)="onClickTableHeader('DecisionToDate')"
            >
              Decision
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'DecisionToDate'
                "
                [color]="searchParameter.sortField === 'DecisionToDate' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
        </dxo-data-table>
        <div class="paginator">
          <dxo-server-pagination
            [itemCount]="applicants.totalResults"
            [currentPage]="searchParameter.page"
            [pageSize]="searchParameter.pageSize"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
          ></dxo-server-pagination>
        </div>
      </card-body>
    </dxo-card>
  </div>
</div>
